import React from 'react';
import { Block } from '@chameleoncreator/creator-app';
import getBlockById from './getBlockById';

// const render = (block: Block, Components: {}): JSX.Element | string => {
//   const children = Array.isArray(block.children)
//     ? (block.children as Block[]).map(b => render(b, Components))
//     : block.children;

//   const Component = Components[block.type];

//   return (
//     <Component key={block.id} id={block.id} {...block.props}>
//       {children}
//     </Component>
//   );
// };

// TODO
// implement something like this
interface IRender {
  [key: string]: (props?: any) => {} | null;
}

const render = (block: Block, Components: {}): JSX.Element | string => {
  let b = block;
  if (b.type === 'Ref') {
    b = getBlockById(b.id);
  }

  const children = Array.isArray(b.children)
    ? (b.children as Block[]).map(c => render(c, Components))
    : b.children;

  let Component = Components[b.type];

  if (Component === null) {
    // we can run this check here
    // or we ' enforce ' the function with types
    // yes. let's TODO that
    Component = () => null;
  } else if (!Component) {
    // console.warn(b, `Component[${b.type}] does not exist.`);
    Component = () => null;
  }

  return (
    <Component key={b.id} id={b.id} {...b.props}>
      {children}
    </Component>
  );
};

export default render;
